// startHereDismissal.js — per-browser, per-user persistence for the home-page
// "Start here" strip's dismissed state (WP3, §5b).
//
// Why a dedicated store instead of onboardingState.updateOnboardingState({...}):
// the shared onboardingState record is normalized to a FIXED shape
// (welcomeDismissedAt, navView, toursCompleted) on every write, so any extra
// field such as `startHereDismissed` is silently dropped and never persists.
// onboardingState is a merged, shared contract owned by another package, so
// rather than widen its schema we keep this one small preference in its own
// namespaced key. Mirrors onboardingState's safe, no-throw storage idioms.

export const START_HERE_STORAGE_PREFIX = 'dha_prime__onboarding_starthere_v1__';

function storageKey(userId) {
  return `${START_HERE_STORAGE_PREFIX}${userId}`;
}

/** True when the signed-in user has dismissed the home "Start here" strip. */
export function readStartHereDismissed(userId) {
  if (!userId || typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(storageKey(userId)) === 'true';
  } catch {
    return false;
  }
}

/** Persist that the user has dismissed the strip. No-throw; falsy userId is a no-op. */
export function setStartHereDismissed(userId) {
  if (!userId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey(userId), 'true');
  } catch {
    /* storage unavailable (private mode / test env) — dismissal simply won't persist */
  }
}
